import gql from 'graphql-tag';

export const saveAchievementMutation = gql`
	mutation SaveAchievementMutation($achievement: String!) {
		userAchievementCreate(values: { achievement: $achievement }) {
			id
		}
	}
`;
